// AboutUs.jsx
import React from 'react';
import CEOMessage from './components/CEOMessage/CEOMessage';
import StatsSection from './components/StatsSection/StatsSection';
import ValuesSection from './components/ValuesSection/ValuesSection';
import { Helmet } from 'react-helmet';
import './AboutUs.css';
import ContactCards from '../Contact/components/ContactCards/ContactCards';

export default function AboutUs() {
  return (
    <>      <Helmet>
            <title>About us</title>
            <meta name="description" content="Welcome to Gladious – experts in sustainable and modern construction projects." />
          </Helmet>
    <div className="about-page">
      <CEOMessage />
      <StatsSection />
       <ContactCards/>
      <ValuesSection />
    </div>
 </>
  );
}